import { init } from './app/init.js';

document.addEventListener('DOMContentLoaded', init);
